import React from 'react';
import PropTypes from 'prop-types';

import './Tag.css';

const Tag = ({ children, onClose }) => {
  return (
    <div className="tag">
      {children}
      <button className="tag-close" onClick={onClose}>&times;</button>
    </div>
  );
};

Tag.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag/Tag.js